module.exports = __webpack_public_path__ + "static/media/shop.96e48f55.svg";